import { render, staticRenderFns } from "./WaybillPostingRX.vue?vue&type=template&id=62e7de06&scoped=true&"
import script from "./WaybillPostingRX.vue?vue&type=script&lang=js&"
export * from "./WaybillPostingRX.vue?vue&type=script&lang=js&"
import style0 from "./WaybillPostingRX.vue?vue&type=style&index=0&id=62e7de06&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e7de06",
  null
  
)

export default component.exports